<template>
  <service-view
    :pictures="pictures"
    :serviceTitle="serviceTitle"
    :architecturalActive="'active'"
    :serviceDescription="serviceDescription"
  />
</template>
<script>
import ServiceView from "./ServiceView";
export default {
  name: "Architectural",
  components: {
    ServiceView
  },
  data: () => ({
    pictures: [
      {
        name: "architectural/IMG-20171102-WA0004.jpg",
        title: "Constructing a factory",
        location: "Zambia"
      },
      {
        name: "architectural/IMG-20171102-WA0006.jpg",
        title: "Swimming pool construction",
        location: "Zambia"
      }
    ],
    serviceTitle: "Architectural",
    serviceDescription:
      "We offer initial consultation, pre-design, and schematic design, design development. construction documents, bidding/contract negotiation and construction contract administration"
  })
};
</script>
